module.exports = __webpack_public_path__ + "static/media/history-drake.60b145cd.mp4";